// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qJ_Py","left":"styles_left__3_kox"};